import TrackingScripts from "../Components/checkoutPageComponent/trackingComponent";
import { images } from "../Constants/imageslinks.js";
import Header from "../Components/ui/header.jsx";
import Footer from "../Components/ui/footer.jsx";

const socialMediaDetails = [
  {
    href: "https://www.instagram.com/minimisphone/",
    icon: images.instagram,
    alt: "instagram icon",
  },
  {
    href: "https://www.linkedin.com/company/minimis-technologies",
    icon: images.linkedIn,
    alt: "linkedin icon",
  },
  {
    href: "https://www.facebook.com/minimistech",
    icon: images.facebook,
    alt: "facebook icon",
  },
];

const socialMedia = socialMediaDetails.map((social, index) => (
  <a href={social.href} target="_blank" rel="noopener noreferrer" key={index}>
    <img src={social.icon} alt={social.alt} />
  </a>
));

const ReservationPage = () => {
  // useEffect(() => {
  //   if (!email) {
  //     navigate("/");
  //   }
  // }, [email, navigate]);

  return (
    <>
      <TrackingScripts />
      <div>
        <div className="bg-primary200">
          <div className="lg:hidden">
            <Header />
          </div>
          <div className="block lg:hidden bg-primary100 md:px-8 px-4 pb-4 pt-5 md:pt-0">
            <div className="md:ml-7 ml-4 flex items-center justify-start">
              <img src={images.checkout_icon} alt="deposit icon" />

              <div className="sm:w-[122px] w-[110px] h-0.5 bg-primary500/20" />

              <img src={images.confirmation_icon} alt="payment icon" />

              <div className="sm:w-[122px] w-[110px] h-[1px] bg-primary500/20" />

              <img src={images.confirmation_icon} alt="confirm icon" />
            </div>

            <div className="flex gap-22 relative mt-2 md:ml-7 ml-4 justify-start">
              <p className="font-inter font-medium text-sm leading-3.5 whitespace-nowrap text-secondary100 ">
                Start
              </p>
              <p className="font-inter font-light text-sm leading-3.5 sm:ml-[109px] ml-[95px] text-secondary100/70">
                Activate
              </p>
              <p className="font-inter font-light text-sm leading-3.5 text-dark-100 sm:ml-[76px] ml-[65px] text-secondary100/70">
                Confirmation
              </p>
            </div>
          </div>
          <div className="3xl:container 3xl:mx-auto bg-primary300 lg:grid grid-cols-12 flex flex-col-reverse">
            <div className="lg:min-h-screen lg:px-[7vw] md:px-8 px-4 3xl:px-[110px] col-span-7">
              <div className="py-[45px] hidden lg:block">
                <img src={images.minimis_logo} alt="minimis logo" />
              </div>

              <div className="lg:block hidden">
                <div className="ml-7 flex items-center justify-start">
                  <img src={images.checkout_icon} alt="deposit icon" />

                  <div className="lg:w-[122px] md:w-[100px] w-[60px] h-[1px] bg-primary500/20" />

                  <img src={images.confirmation_icon} alt="payment icon" />

                  <div className="w-[122px] h-[1px] bg-primary500/20" />

                  <img src={images.confirmation_icon} alt="confirm icon" />
                </div>

                <div className="flex gap-22 relative mt-2 ml-7 justify-start">
                  <p className="font-inter font-medium text-sm leading-3.5 text-secondary100">
                    Start
                  </p>
                  <p className="font-inter font-light text-sm leading-3.5 ml-[109px] text-secondary100/70">
                    Activate
                  </p>
                  <p className="font-inter font-light text-sm leading-3.5 text-dark-100 ml-[74px] text-secondary100/70">
                    Confirmation
                  </p>
                </div>
              </div>

              <div className="flex flex-col items-start md:gap-[16px] gap-6 md:pt-[20px] pt-[30px] pb-[30px]">
                <p className="font-light text-[32px] leading-12 text-secondary100">
                  Check your inbox!
                </p>
                <div className="font-normal text-base leading-6 text-secondary100 flex flex-col gap-[16px]">
                  <p>
                    We’ve sent you an email to verify your address. Click the
                    link inside to continue setting up your 30-day free trial.
                  </p>
                  <p>
                    If you run into any issues, please email us at
                    hey@minimis.life :)
                  </p>
                  <div className="bg-primary200 p-4 flex flex-col gap-3 md:mt-6 mt-4">
                    <p className="font-normal text-base leading-[21px]">
                      <span className="font-bold">Important:</span> The
                      verification email will be sent to the address you
                      provided earlier. To redeem your access after installing
                      the app, please use the same email you verified.
                    </p>
                  </div>
                  <div className="flex gap-10 md:mt-6 mt-4">{socialMedia}</div>
                </div>
              </div>
            </div>
            <div className="col-span-5 bg-primary200 flex justify-center items-start lg:pt-12 pt-16">
              <img
                src={images.hero_image}
                alt="hero image"
                className="w-full max-w-[480px]"
              />
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
};

export default ReservationPage;
